import {
  arrayOf, shape, string, bool, number,
} from 'prop-types';
import categoryDataType from './categoryDataType';

const groupedCategoryDataType = shape({
  name: string,
  pagination: shape({
    currentPage: number,
    totalPages: number,
  }),
  productTotalCount: number,
  fullCatHead: bool,
  subCategories: arrayOf(categoryDataType),
});

export default groupedCategoryDataType;
